import {
  hasCleanTaxCredit,
  maybeHasGreatDealTag,
  useHasDealTag
} from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import { useTileDataContext } from '~/contexts/TileDataContext';
import usePriceDrop from '~/hooks/usePriceDrop';
import EvCreditTag from './EvCreditTag';
import GreatDealTag from './GreatDealTag';
import NewPriceTag from './NewPriceTag';

const StatusTags = () => {
  const { tileData } = useTileDataContext();
  const hasTag = useHasDealTag(tileData);
  const showGreatDeal = maybeHasGreatDealTag(tileData);
  const { getPriceDrop } = usePriceDrop();
  const { showPriceDrop } = getPriceDrop(tileData);
  const showEvTag = hasCleanTaxCredit(tileData);

  return (
    <div className={`${hasTag ? 'flex' : 'hidden'} m:flex gap-4`}>
      {showPriceDrop && <NewPriceTag />}
      {showGreatDeal && <GreatDealTag />}
      {showEvTag && <EvCreditTag />}
    </div>
  );
};

export default StatusTags;
